import {
  Home,
  ClipboardList,
  UserCheck,
  FileText,
  Menu,
  X,
  LogOut,
  Settings,
  Loader2,
  Plus,
  UserPlus,
  ArrowLeft,
  ArrowRight,
  AlertTriangle,
  Building,
  BarChart3,
  CheckCircle,
  Globe,
  Database,
  Phone,
  Calendar,
  User,
  NotebookPen,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Target,
  Star,
  Trash2,
  RotateCcw,
  Info,
  Briefcase,
  Edit,
  AlertCircle,
  Zap,
  Folder,
  Hash,
  Tag,
  Shield,
  Mail,
  Copy,
  Search,
  Eye,
  Save,
  DollarSign,
  MessageCircle,
  Send,
  Bot,
  Minimize,
  Share,
  Activity,
} from "lucide-react"
import {
  Brain,
  UserList,
  House,
  IdentificationCard,
  Users,
  SignOut,
  EyeSlash,
  EyeClosed,
  Megaphone,
  Sparkle,
  FileArrowDown,
  EnvelopeSimple,
  Gear,
  Files,
  UserCirclePlus,
  AddressBook,
  FacebookLogo,
  Calculator,
  Heartbeat,
  Buildings,
  TicketIcon,
} from "@phosphor-icons/react"

export const Icons = {
  home: Home,
  clipboardList: ClipboardList,
  userCheck: UserCheck,
  fileText: FileText,
  menu: Menu,
  x: X,
  logOut: SignOut,
  brain: Brain,
  userList: UserList,
  house: House,
  document: IdentificationCard,
  users: Users,
  eye: Eye,
  eyeSlash: EyeSlash,
  eyeClosed: EyeClosed,
  megaphone: Megaphone,
  sparkle: Sparkle,
  chat: MessageCircle,
  fileArrowDown: FileArrowDown,
  envelopeSimple: EnvelopeSimple,
  cog: Settings,
  settings: Settings,
  gear: Gear,
  spinner: Loader2,
  files: Files,
  plus: Plus,
  userPlus: UserPlus,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  warning: AlertTriangle,
  building: Building,
  barChart: BarChart3,
  checkCircle: CheckCircle,
  globe: Globe,
  database: Database,
  phone: Phone,
  calendar: Calendar,
  user: User,
  notepad: NotebookPen,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  userCirclePlus: UserCirclePlus,
  addressBook: AddressBook,
  target: Target,
  star: Star,
  trash: Trash2,
  refresh: RotateCcw,
  info: Info,
  briefcase: Briefcase,
  edit: Edit,
  alertCircle: AlertCircle,
  zap: Zap,
  folder: Folder,
  hash: Hash,
  tag: Tag,
  shield: Shield,
  mail: Mail,
  copy: Copy,
  search: Search,
  save: Save,
  calculator: Calculator,
  dollarSign: DollarSign,
  messageCircle: MessageCircle,
  send: Send,
  bot: Bot,
  minimize: Minimize,
  share: Share,
  facebook: FacebookLogo,
  activity: Activity,
  heart: Activity,
  heartbeat: Heartbeat,
  buildings: Buildings,
  calculator: Calculator,
  ticket: TicketIcon
} 
